import { render, staticRenderFns } from "./CardsCreateFormSidebar.vue?vue&type=template&id=afda025e&scoped=true"
import script from "./CardsCreateFormSidebar.vue?vue&type=script&lang=js"
export * from "./CardsCreateFormSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afda025e",
  null
  
)

export default component.exports